import { render } from "./TwoFactorForm.vue?vue&type=template&id=19cf4c9d"
import script from "./TwoFactorForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorForm.vue?vue&type=script&lang=js"

import "./TwoFactorForm.vue?vue&type=style&index=0&id=19cf4c9d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__